<template>
  <div>
    <add-note-dialog
      ref="addNoteDialog"
      @onInsert="refresh()"
    />
    <add-payment-dialog
      ref="addPaymentDialog"
      @onInsert="refresh()"
    />
    <edit-booking-dialog
      ref="editBookingDialog"
      @onUpdate="refresh()"
    />
    <add-add-ons-dialog
      ref="addAddOnsDialog"
      @onInsert="refresh()"
    />
    <v-card
      v-if="booking.bookingId > 0"
      class="pt-0"
    >
      <v-toolbar
        dark
        color="primary"
      >
        <h1 :class="{'subtitle-1': isMobile()}">
          [{{ booking.bookingId }}] {{ booking.event }}
        </h1>
        <v-spacer></v-spacer>
        <event-status
          :status="booking.eventStatusId"
          :size="parseInt('40')"
        />
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>{{ mdiDotsVertical }}</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item>
              <table-action-button
                :icon="mdiPencilOutline"
                text="Editar"
                @OnClick="editBookingDialog.ShowEditDialog(booking.bookingKey)"
              />
            </v-list-item>
            <v-list-item>
              <table-action-button
                :icon="mdiCashRegister "
                text="Agregar Pago"
                @OnClick="addPaymentDialog.ShowDialog(booking)"
              />
            </v-list-item>
            <v-list-item>
              <table-action-button
                :icon="mdiNotePlusOutline"
                text="Agregar Nota"
                @OnClick="addNoteDialog.ShowDialog(booking)"
              />
            </v-list-item>
            <v-list-item>
              <table-action-button
                :icon="mdiCartPlus "
                text="Agregar AddOns"
                @OnClick="addAddOnsDialog.ShowDialog(booking)"
              />
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          class="ml-5"
          icon
          @click="AskToClose()"
        >
          <v-icon>{{ mdiCloseCircle }}</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col
            lg="4"
            cols="12"
          >
            <v-list>
              <text-list-item
                title="Cliente"
                :text="booking.client"
              />
              <text-list-item
                title="Correo Electrónico"
                :text="booking.email"
              />
              <text-list-item
                title="Teléfono"
                :text="booking.phone"
              />
              <text-list-item
                title="Fecha de Creación"
                :text="booking.createdOn | date"
              />
              <text-list-item
                title="Vendedor(a)"
                :text="booking.salesPerson"
              />
              <text-list-item
                title="Fotógrafo(a)"
                :text="booking.photographer"
              />
            </v-list>
          </v-col>
          <v-col
            lg="4"
            cols="12"
          >
            <v-list>
              <text-list-item
                title="Locación"
                :text="booking.location"
              />

              <text-list-item
                title="Fecha / hora"
                html
                :text="booking.startDate | datediff(booking.endDate)"
              />

              <text-list-item
                title="Temporalidad"
                :text="daysToDate"
              />

              <text-list-item
                v-if="booking.promo"
                title="Promo"
                :text="booking.promo"
              />
            </v-list>
          </v-col>
          <v-col
            lg="4"
            cols="12"
          >
            <v-list>
              <text-list-item
                v-for="data in sortedMetadata"
                :key="data.position"
                :title="data.question"
                :text="data.answer"
              />
            </v-list>
          </v-col>
        </v-row>
        <div class="d-sm-flex flex-wrap">
          <payments-resume
            ref="paymentsResume"
            :booking="booking"
          />
          <notes-resume
            ref="notesResume"
            :booking="booking"
          />
          <add-ons-resume
            ref="addOnsResume"
            :booking="booking"
          />
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import {
  mdiCurrencyUsd, mdiCloseCircle, mdiDotsVertical, mdiPencilOutline,
  mdiCashRegister, mdiNotePlusOutline, mdiCartPlus,
} from '@mdi/js'
import { ref, computed } from '@vue/composition-api'
import moment from 'moment'
import TextListItem from '@/components/controls/TextListItem.vue'
import EventStatus from '@/components/statusIcon/EventStatus.vue'
import store from '@/store'
import PaymentsResume from '@/views/payments/components/PaymentsResume.vue'
import NotesResume from '@/views/notes/components/NotesResume.vue'
import AddOnsResume from '@/views/addOns/components/AddOnsResume.vue'
import isMobileScript from '@/scripts/helpers/isMobile'
import daysTo from '@/scripts/helpers/daysTo'

import AddPaymentDialog from '@/views/payments/components/AddPaymentDialog.vue'
import TableActionButton from '@/components/controls/TableActionButton.vue'
import AddNoteDialog from '@/views/notes/components/AddNoteDialog.vue'
import AddAddOnsDialog from '@/views/addOns/components/AddAddOnsDialog.vue'
import EditBookingDialog from './EditBookingDialog.vue'

export default {
  components: {
    TextListItem,
    EventStatus,
    PaymentsResume,
    NotesResume,
    AddOnsResume,
    AddPaymentDialog,
    TableActionButton,
    AddNoteDialog,
    AddAddOnsDialog,
    EditBookingDialog,
  },
  setup(_, { emit }) {
    const isMobile = isMobileScript
    const emptyBooking = ref({
      bookingId: 0,
      email: '',
      client: '',
      phone: '',
      event: '',
      startDate: '',
      endDate: '',
      location: '',
      eventStatusId: 0,
      price: 0,
      payStatusId: 0,
      promo: '',
      createdOn: '',
      metadata: '',
      active: 0,
      bookingKey: '',
      eventKey: '',
      promoKey: '',
    })

    const booking = ref({
      bookingId: 0,
      email: '',
      client: '',
      phone: '',
      event: '',
      startDate: '',
      endDate: '',
      location: '',
      eventStatusId: 0,
      price: 0,
      payStatusId: 0,
      promo: '',
      createdOn: '',
      metadata: '',
      active: 0,
      bookingKey: '',
      eventKey: '',
      promoKey: '',
    })

    const GetBooking = bookingKey => {
      store.dispatch('bookings/apiCall', { mode: 'Select', request: { key: bookingKey } }).then(result => {
        if (result.success) {
          booking.value = result.data
        }
      })
    }

    const sortedMetadata = computed(() => {
      if (booking.value.metadata !== '') {
        const metadataArray = JSON.parse(booking.value.metadata)

        return metadataArray.sort((a, b) => a.position - b.position)
      }

      return []
    })

    const daysToDate = computed(() => {
      const a = moment.utc(new Date()).local()
      const b = moment(booking.value.startDate)

      return daysTo(b, a)
    })

    const AskToClose = () => {
      booking.value = emptyBooking.value
      emit('askToClose')
    }

    /** Edit Dialog ********************* */
    const editBookingDialog = ref()

    /** AddOns Dialog ********************* */
    const addAddOnsDialog = ref()

    /** Notes Add Dialog ********************* */
    const addNoteDialog = ref()

    /** Payments Add Dialog ****************** */
    const addPaymentDialog = ref()

    /** Resume */
    const paymentsResume = ref()
    const notesResume = ref()
    const addOnsResume = ref()

    const refresh = () => {
      GetBooking(booking.value.bookingKey)
      paymentsResume.value.refresh()
      notesResume.value.refresh()
      addOnsResume.value.refresh()
    }

    return {
      isMobile,
      GetBooking,
      AskToClose,
      refresh,

      /** Edit Dialog  */
      editBookingDialog,

      /** AddOns Dialog */
      addAddOnsDialog,

      /** Notes Add Dialog */
      addNoteDialog,

      /** Payments Add Dialog */
      addPaymentDialog,

      /** Resume */
      paymentsResume,
      notesResume,
      addOnsResume,

      booking,
      sortedMetadata,
      daysToDate,
      mdiCurrencyUsd,
      mdiCloseCircle,
      mdiDotsVertical,
      mdiPencilOutline,
      mdiCashRegister,
      mdiNotePlusOutline,
      mdiCartPlus,
    }
  },
}
</script>
